import Icon from '../components/Icon.vue'

Icon.register({"ruler-vertical":{"width":256,"height":512,"paths":[{"d":"M168 416C163.6 416 160 412.4 160 408V392C160 387.6 163.6 384 168 384H256V320H168C163.6 320 160 316.4 160 312V296C160 291.6 163.6 288 168 288H256V224H168C163.6 224 160 220.4 160 216V200C160 195.6 163.6 192 168 192H256V128H168C163.6 128 160 124.4 160 120V104C160 99.6 163.6 96 168 96H256V32C256 14.3 241.7 0 224 0H32C14.3 0 0 14.3 0 32V480C0 497.7 14.3 512 32 512H224C241.7 512 256 497.7 256 480V416H168z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ruler-vertical.js
// module id = 0Cxk
// module chunks = 0